import { AuthenticatedFetchErrorJSON } from '../../../Common/Definitions';
import { NetworkLocation, StoreConfiguration } from '../../../Common/TypeDefinitions';
import { HTTPFetchResponse, HeadersJson } from '../../../utils/http/Http';
import { AuthBridgeBase } from './AuthBridgeBase';

export class AccountConfigToAuthDirectBridge extends AuthBridgeBase {
	private constructor() {
		super();
	}

	private static _instance: AccountConfigToAuthDirectBridge;

	static get Instance(): AccountConfigToAuthDirectBridge {
		return (
			AccountConfigToAuthDirectBridge._instance ||
			(AccountConfigToAuthDirectBridge._instance = new AccountConfigToAuthDirectBridge())
		);
	}

	public async gatewayAuthenticatedFetch(params: string): Promise<HTTPFetchResponse> {
		return await window.gatewayAuthenticatedFetch(params);
	}

	public async getGatewayRoamingAccountsResponse(
		url: string
	): Promise<HTTPFetchResponse> {
		return await window.getGatewayRoamingAccountsResponse(url);
	}

	public setReferenceUriToGatewaySession(
		sessionUrl: URL,
		referenceUri: string
	): Promise<boolean> {
		return Promise.resolve(
			window.setReferenceUriToGatewaySession(sessionUrl, referenceUri)
		);
	}

	public async authFetch(
		method: string,
		url: string,
		headers: HeadersJson,
		body: string,
		referenceUri: string,
		allowCredUi: boolean,
		id?: string
	): Promise<HTTPFetchResponse> {
		return await window.authFetch(
			method,
			url,
			headers,
			body,
			referenceUri,
			allowCredUi,
			id ?? ''
		);
	}

	public async gatewayAuthenticatedFetchWrapper(
		params: string
	): Promise<HTTPFetchResponse | AuthenticatedFetchErrorJSON> {
		return await window.gatewayAuthenticatedFetchWrapper(params);
	}

	public async authFetchWrapper(
		params: string
	): Promise<HTTPFetchResponse | AuthenticatedFetchErrorJSON> {
		return await window.authFetchWrapper(params);
	}

	public async getStoreConfiguration(): Promise<StoreConfiguration> {
		return await window.getStoreConfiguration?.();
	}

	public async getNetworkLocation(params: string): Promise<NetworkLocation> {
		return await window.getNetworkLocation(params);
	}

	public async getNetworkLocationForURL(params: string): Promise<NetworkLocation> {
		return await window.getNetworkLocationForURL(params);
	}

	public async evaluateNetworkLocationAndStoreConfiguration(
		params: string
	): Promise<void> {
		return await window.evaluateNetworkLocationAndStoreConfiguration(params);
	}
}
